module.exports = __webpack_public_path__ + "static/media/insect(3).0e86bd7f.PNG";